module.exports = __webpack_public_path__ + "static/media/Desktop_Weather.508da2e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haf/Desktop_Weather.png
// module id = 85
// module chunks = 0